module.exports = __webpack_public_path__ + "img/why3.efeedddf.png";